import { z } from 'zod';
export const quoteImportRequestSchema = z.object({
    eventId: z.string().uuid(),
    documentId: z.string().uuid(),
});
export const quoteImportConfirmSchema = z.object({
    eventId: z.string().uuid(),
    documentId: z.string().uuid(),
    vendorId: z.string().uuid().optional(),
    vendorName: z.string().max(255).optional(),
    items: z.array(z.object({
        description: z.string(),
        quantity: z.number().min(0),
        unitPrice: z.number().min(0),
        totalPrice: z.number().min(0),
        category: z.string().optional(),
        accepted: z.boolean(),
        vendorCategoryId: z.string().uuid().optional(),
        statusId: z.string().uuid().optional(),
    })),
});
//# sourceMappingURL=quote-import.js.map